import { render, staticRenderFns } from "./directPower.vue?vue&type=template&id=1884d840&scoped=true"
import script from "./directPower.vue?vue&type=script&lang=js"
export * from "./directPower.vue?vue&type=script&lang=js"
import style0 from "./directPower.vue?vue&type=style&index=0&id=1884d840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884d840",
  null
  
)

export default component.exports